import React, { useMemo } from "react";
import {
    RuleConditionType,
    TransactionRule,
} from "../../../common/types/transactionRule";
import { useWorkspaceAccounts } from "../../../api/account.api";
import styles from "./RuleEntityAction.module.scss";

interface Props {
    rule: Pick<TransactionRule, "accountId" | "accountNumber" | "conditions">;
}

export const RuleAccountAction: React.FC<Props> = ({ rule }) => {
    const { data: accounts } = useWorkspaceAccounts();

    const entityCondition = rule.conditions.find(
        (c) => c.conditionType === RuleConditionType.ENTITY,
    );

    const account = useMemo(
        () =>
            accounts?.find((a) => {
                if (rule.accountNumber) {
                    return (
                        a.code === Number(rule.accountNumber) &&
                        (entityCondition?.value as number[]).includes(
                            a.entityId,
                        )
                    );
                } else if (rule.accountId) {
                    return (
                        a.id === rule.accountId &&
                        (entityCondition?.value as number[]).includes(
                            a.entityId,
                        )
                    );
                }
                return false;
            }),
        [accounts, entityCondition?.value, rule.accountNumber, rule.accountId],
    );

    if (!account) {
        return null;
    }

    return (
        <div>
            Assign to{" "}
            <div className={styles.entityLead}>
                <strong>{account.code}</strong> - {account?.name}
            </div>
            .
        </div>
    );
};
